import React, { useState, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { Container, Row, Col } from 'react-bootstrap';
import axiosInterceptor from '../../services/axiosInterceptor';
import ProfileTable from './ProfileTable';
import AccountSettings from './AccoutSettings';

function MyProfilePage(props) {
    const [authCookie, setAuthCookie] = useCookies(['oauth_token']);

    const [userName, setUserName] = useState('');
    const [email, setEmail] = useState('');

    useEffect(() => {
        getUserName();
    }, [authCookie?.oauth_token]);

    let getUserName = async () => {
        // Get Username and Email from Oauth Token
        const username_data = await axiosInterceptor().post(
            'twitter/auth/getUserName',
            { oauth_token: authCookie?.oauth_token }
        );

        if (username_data?.data?.username) {
            setUserName(username_data?.data?.username);
        }

        if (username_data?.data?.email) {
            setEmail(username_data?.data?.email);
        }
    };

    return (
        <Container fluid>
            <Row>
                <AccountSettings username={userName} logout={props.logout} />
            </Row>
            <Row>
                <Col>
                    <hr className="mt-2 mb-3" />
                    <ProfileTable username={userName} email={email} />
                </Col>
            </Row>
        </Container>
    );
}

export default MyProfilePage;
